import { BlockOutlined, Delete as DeleteIcon } from '@mui/icons-material';
import {
    Button,
    Card,
    Container,
    IconButton,
    Paper,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from '@mui/material';
import React, { useState } from 'react';
import { useConfirm } from 'material-ui-confirm';
import useErrors from '../../../hooks/useErrors';
import { useFetch } from '../../../hooks/useFecth';
import server from '../../../services/server';
import ConfirmationModal from '../../../components/ConfirmationModal';

export default function ListWebhooks() {
    const { data, mutate, isFetching } = useFetch('payment/asaas/webhooks');
    const { setErrors, enqueueSnackbar } = useErrors();
    const confirm = useConfirm();
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [confirmAction, setConfirmAction] = useState(null);
    const [deletingId, setDeletingId] = useState(null);

    const webhooks = Array.isArray(data) ? data : data?.data ?? [];

    const handleDelete = webhookId => {
        setDeletingId(webhookId);
        setConfirmAction(() => async () => {
            try {
                await server.delete(`payment/asaas/webhooks/${webhookId}`);
                enqueueSnackbar('Webhook removido com sucesso.');
                await mutate();
            } catch (error) {
                setErrors(error);
            }
            setConfirmOpen(false);
            setDeletingId(null);
        });
        setConfirmOpen(true);
    };

    return (
        <Container>
            <Stack spacing={0.5} pb={2}>
                <Typography variant="h2">Webhooks Asaas</Typography>
                <Typography variant="body2" color="text.secondary">
                    Gerencie os webhooks configurados para integração com Asaas.
                </Typography>
            </Stack>

            <Card>
                <TableContainer component={Paper} variant="outlined" sx={{ border: 0 }}>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>URL</TableCell>
                                <TableCell>Eventos</TableCell>
                                <TableCell>Status</TableCell>
                                <TableCell align="right" width={80} />
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {!webhooks?.length && !isFetching ? (
                                <TableRow>
                                    <TableCell colSpan={4}>
                                        <Stack direction="row" justifyContent="center" alignItems="center" gap={1} py={3}>
                                            <Typography color="text.secondary">Nenhum webhook encontrado.</Typography>
                                            <BlockOutlined />
                                        </Stack>
                                    </TableCell>
                                </TableRow>
                            ) : (
                                webhooks?.map(webhook => (
                                    <TableRow key={webhook.id || webhook.url} hover>
                                        <TableCell>{webhook.url || webhook.webhookUrl || '—'}</TableCell>
                                        <TableCell>
                                            {Array.isArray(webhook.events) ? webhook.events.join(', ') : webhook.events || '—'}
                                        </TableCell>
                                        <TableCell>{webhook.status || webhook.active ? 'Ativo' : 'Inativo'}</TableCell>
                                        <TableCell align="right">
                                            <IconButton
                                                onClick={() => handleDelete(webhook.id || webhook.webhookId)}
                                                title="Remover"
                                                size="small"
                                                color="error"
                                                disabled={deletingId === (webhook.id || webhook.webhookId)}
                                            >
                                                <DeleteIcon />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                ))
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Card>

            <ConfirmationModal
                open={confirmOpen}
                onClose={() => {
                    setConfirmOpen(false);
                    setDeletingId(null);
                }}
                onConfirm={confirmAction}
                title="Remover webhook"
                message="Tem certeza que deseja remover este webhook?"
            />
        </Container>
    );
}
